import { IImageDimensions } from '../../types';

export const processImageDimensions = (file: File): Promise<IImageDimensions | null> =>
  new Promise<IImageDimensions>((resolve) => {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      (event) => {
        const dataURL: string = event.target.result as string;
        const imageObj = new Image();

        imageObj.src = dataURL;
        imageObj.onerror = () => {
          // @@LOG
          resolve(null);
        };
        imageObj.onload = () => {
          resolve({ width: imageObj.width, height: imageObj.height });
        };
      },
      false
    );
    reader.readAsDataURL(file);
  });
